import React from "react";

const DetailRow = ({
  label,
  value,
  labelClassName = "",
  valueClassName = "",
}) =>
  value ? (
    <div className="row w-100">
      <div
        className={`col-12 col-md-4 col-lg-3 col-xl-2 py-1 py-md-2 detail-row-heading ${labelClassName}`}
      >
        {label}
      </div>
      <div
        className={`col-12 col-md-8 col-lg-9 col-xl-10 py-1 py-md-2 detail-row-info ${valueClassName}`}
      >
        {value}
      </div>
    </div>
  ) : null;

export default DetailRow;
